import { Fragment, useEffect, useState } from "react"
import { Link, useParams } from "react-router-dom"
import { Badge, Button, Card, CardBody, CardHeader, Col, Container, Form, FormGroup, Input, Label, ListGroup, ListGroupItem, Row, Table } from "reactstrap"
import Utils from "../../Utils"
import ModalEditarLote from "../../modals/ModalEditarLote"

const GestionarDescuentos = ({ Slug, descuentos, MaxCuotas, fetchLotes }) => {


    const DEFAULT_FORM = {
        Inicial: 0,
        Descuento: 0,
        MaximoMeses: 0,
        TipoDescuento: "porcentaje"
    }
    
    const [form, setForm] = useState(DEFAULT_FORM)

    const handleInputChange = ({ target }) => {
        setForm({
            ...form,
            [target.name]: target.value
        })
    }

    const borrarDescuento = async idDescuento => {
        if(window.confirm("Realmente quieres eliminar el descuento?")) {
            try {
                await Utils.API.EliminarDescuento(idDescuento)
                //refresh
                fetchLotes()
            } catch(err) {
                Utils.AlertError(err, "No se pudo eliminar el Descuento")
            }
        }
    }

    const onSubmit = async event => {
        event.preventDefault()
        if(window.confirm(`Realmente quiere crear el descuento de: Incial: ${form.Inicial} / Descuento: ${form.Descuento} ?`)) {
            // try to create
            try {
                const _maxMeses = (form.MaximoMeses > 0 && form.MaximoMeses != MaxCuotas) ? form.MaximoMeses : null
                await Utils.API.CrearDescuento(Slug, form.Inicial, form.Descuento, form.TipoDescuento, _maxMeses)
                //refresh
                fetchLotes()
                // reset form
                setForm(DEFAULT_FORM)
            } catch(err) {
                Utils.AlertError(err, "No se pudo crear el Descuento")
            }
        }
    }
    
    const showDescuento = (Descuento, TipoDescuento="porcentaje") => {
        const simbolo = (TipoDescuento == "porcentaje") ? "%" : "$"
        const precio = (TipoDescuento == "porcentaje") ? Descuento : Utils.formatPrice(Descuento)
        return `${precio}${simbolo}`
    }

    return(
        <Row className="my-2 only-screen">
            <Col>
                <Card>
                    <CardHeader className="bg-primary text-white h5">Descuentos</CardHeader>
                    <>
                        {(descuentos.length == 0) ?
                            <CardBody>
                                <span className="text-danger">Sin Descuentos</span>
                            </CardBody>
                            :
                            <ListGroup flush>
                                {descuentos.map(({ idDescuento, Inicial, Descuento, TipoDescuento, MaxMeses }) => (
                                    <ListGroupItem key={`Descuento_${idDescuento}`}>
                                        <Badge className="py-1 px-2" pill>Meses: {MaxMeses}</Badge> /{" "}
                                        <Badge className="py-1 px-2" pill>Inicial: {Inicial}%</Badge> /{" "}
                                        <Badge className="py-1 px-2" pill>Descuento: {showDescuento(Descuento, TipoDescuento)}</Badge>{" "}
                                        <Badge className="cursorLink" onClick={() => { borrarDescuento(idDescuento) }} color="danger">
                                            <i className="fa-solid fa-trash"></i>
                                        </Badge>
                                    </ListGroupItem>
                                ))}
                            </ListGroup>
                        }
                    </>
                </Card>
            </Col>
            <Col>
                <Card>
                    <CardHeader className="bg-primary text-white h5">Añadir Descuento</CardHeader>
                    <CardBody>
                        <Form onSubmit={onSubmit}>
                            <Row>
                                <Col>
                                    <FormGroup>
                                        <Label>Inicial:</Label>
                                        <Input onChange={handleInputChange} name="Inicial" value={form.Inicial} type="number" min={0} max={100} />
                                    </FormGroup>
                                </Col>
                                <Col>
                                    <FormGroup>
                                        <Label>Descuento:</Label>
                                        <Input onChange={handleInputChange} name="Descuento" value={form.Descuento} type="number" step={"0.0001"} min={0} max={(form.TipoDescuento == "porcentaje") ? 50 : undefined} />
                                    </FormGroup>
                                </Col>
                            </Row>
                            <Row>
                                <Col sm={5}>
                                    <FormGroup>
                                        <Label>Tipo Descuento:</Label>
                                        <Input onChange={handleInputChange} name="TipoDescuento" value={form.TipoDescuento} type="select">
                                            <option value={"porcentaje"}>Porcentaje (%)</option>
                                            <option value={"monto"}>Monto ($)</option>
                                        </Input>
                                    </FormGroup>
                                </Col>
                                <Col>
                                    <FormGroup>
                                        <Label>Máximo Meses ({MaxCuotas}):</Label>
                                        <Input onChange={handleInputChange} name="MaximoMeses" value={form.MaximoMeses} type="number" min={0} max={MaxCuotas} />
                                    </FormGroup>
                                </Col>
                            </Row>

                            <Button block>Crear Descuento</Button>
                            
                        </Form>
                    </CardBody>
                </Card>
            </Col>
        </Row>
    )
}

const TablaLotes = ({ precios, fetchLotes }) => {

    const { MaxCuotas } = precios

    const [lote, setLote] = useState({
        Precio: "",
        Area: "",
        ManzanaLote: ""
    })

    const [isOpen, setIsOpen] = useState(false)

    const { descuentos, lotes } = precios

    const setDisponibilidad = async (idLote, ocupado) => {
        if(window.confirm('Realmente desea cambiar la disponibilidad del lote?')) {
            try {
                await Utils.API.SetLoteOcupado(idLote, ocupado)
                // refresh
                fetchLotes()
            }catch(err) {
                Utils.AlertError(err, "No se pudo cambiar la disponibilidad del lote")
            }
        }
    }
    const openModal = _lote => {
        setLote(_lote)
        setIsOpen(true)
    }

    const closeModal = () => {
        setIsOpen(false)
    }

    return(
        <>
        <div>
            {Object.keys(lotes).map((etapa, indxEtapa) => {
                const _etapaLotes = lotes[etapa]
                return (
                    <div key={`Etapa_${indxEtapa}`}>

                        <h3 fontSize={20}>Etapa {etapa}:</h3>

                        {Object.keys(_etapaLotes).map((manzana, index) => {
                            const _lotes = _etapaLotes[manzana]
                            return(
                                <Fragment key={index}>
                                    <h4 className="text-primary">Manzana {manzana}:</h4>
                                    <Table bordered className="text-center">
                                        <thead>
                                            <tr>
                                                <th>
                                                    Lote
                                                </th>
                                                <th>
                                                    Área
                                                </th>
                                                <th>
                                                    Partida Registral
                                                </th>
                                                <th>
                                                    Precio
                                                </th>
                                                {descuentos.map((dscto, indx) => (
                                                    <th key={`dscto_${indx}_${dscto.idDescuento}`}>
                                                        {dscto.label}
                                                    </th>
                                                ))}
                                                <th>
                                                    <span className="only-screen">Operaciones</span>
                                                    <span className="only-print">Estado</span>
                                                </th>
                                            </tr>
                                        </thead>
                                        
                                        <tbody>
                                            {_lotes.map((item, indx) => (
                                                <tr key={`TL_${indx}_${manzana}`}>
                                                    <th scope="row">
                                                        {item.ManzanaLote}
                                                    </th>
                                                    <td>{item.Area}</td>
                                                    <td>
                                                        {(item.PartidaRegistral == null) ?
                                                            <Badge>Sin partida</Badge>
                                                            :
                                                            <Badge color="success">{item.PartidaRegistral}</Badge>
                                                        }
                                                    </td>
                                                    <td>{item.Precio}</td>
                                                    {item.descuentos.map((dscto, indx) => (
                                                        <td key={`dscto_${index}_${item.idLote}-${indx}`}>
                                                            {dscto.PrecioDescuento}
                                                        </td>
                                                    ))}
                                                    <td>
                                                        <div className="only-screen">
                                                            <Button onClick={() => { openModal(item) }} outline color="primary">
                                                                <i className="fa-solid fa-file-pen"></i> Modificar
                                                            </Button>
                                                            
                                                            {item.Ocupado ?
                                                                <>
                                                                    {(item.idOwner == null) ?
                                                                        <Button onClick={() => { setDisponibilidad(item.idLote, false) }} outline color="secondary" className="m-1">
                                                                            <i className="fa-solid fa-check"></i> Disponible
                                                                        </Button>
                                                                    :
                                                                        <Badge color="danger" className="m-2">Lote Vendido</Badge>
                                                                    }
                                                                </>
                                                                :
                                                                <>
                                                                    <Link to={`/Ventas?idLote=${item.idLote}`} className="m-1 btn btn-outline-success">
                                                                        <i className="fa-solid fa-hand-holding-dollar"></i> Vender
                                                                    </Link>
                                                                    <Button onClick={() => { setDisponibilidad(item.idLote, true) }} outline color="warning" className="m-1">
                                                                        <i className="fa-solid fa-xmark"></i>  No Disponible
                                                                    </Button>
                                                                </>
                                                            }
                                                        </div>
                                                        <div className="only-print">
                                                        {(item.Ocupado == true) ?
                                                                <Badge color="danger">VENDIDO</Badge>
                                                                :
                                                                <Badge color="success">DISPONIBLE</Badge>
                                                            }
                                                        </div>
                                                        
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </Table>
                                </Fragment>
                            )
                        })}
                    </div>
                )
            })}
            <div>
            
            </div>
            
        </div>
        <ModalEditarLote
            isOpen={isOpen}
            lote={lote}
            closeModal={closeModal}
            fetchLotes={fetchLotes}
        />
        </>
    )



}

const GestionarProyecto = () => {
    const { Slug } = useParams()

    const [lotes, setData] = useState(null)

    const fetchLotes = async () => {
        try {
            const { data } = await Utils.API.ListarLotes(Slug)
            setData(data)
        } catch(err) {
            Utils.AlertError(err, "No se pudieron cargar los lotes")
        }
    }

    useEffect(() => {
        fetchLotes()
    }, [])

    return(
        <Container>

            {(lotes == undefined) ?
                <h1>Cargando</h1>
                :
                <>
                    <GestionarDescuentos
                        descuentos={lotes.descuentos}
                        fetchLotes={fetchLotes}
                        Slug={Slug}
                        MaxCuotas={(lotes == null) ? 0 : lotes.MaxCuotas}
                    />

                    {(Object.keys(lotes.lotes).length === 0) ?
                        <h3 className="text-danger">No existen etapas para este Proyecto</h3>
                        :
                        <TablaLotes fetchLotes={fetchLotes} precios={lotes} />
                    }
                </>
            }

        </Container>
    )
}

export default GestionarProyecto